import angular from 'angular';

import DealTypeFactory from './dealTypeFactory';


export default angular.module('app.appDetail.addProducts.dealType', [])
    .factory('DealTypeFactory', DealTypeFactory)
    .run()
    .name;



// WEBPACK FOOTER //
// ./src/app/appDetail/addProducts/dealType/index.js